import { http } from '@/lib/http';

export type UploadKind = 'logo' | 'job_attachment';

/**
 * Body for `POST /businesses/{business_id}/uploads` — mirrors
 * `controller.createUploadRequest`. `job_id` is required when
 * `kind === 'job_attachment'`.
 */
export interface CreateUploadRequest {
  kind: UploadKind;
  job_id?: string;
  content_type: string;
}

/** Mirrors `controller.uploadResponse` in the vizitpro-api swagger spec. */
export interface UploadDto {
  upload_url: string;
  public_url: string;
  key: string;
  expires_at: string;
}

/**
 * Calls `POST /businesses/{business_id}/uploads`. Returns a time-limited
 * presigned URL to `PUT` the raw file bytes to directly (no auth header),
 * plus the `public_url` to persist afterward via the resource's own
 * endpoint (`PATCH /businesses/{id}` for a logo, `POST .../attachments` for
 * a job attachment).
 */
export async function requestUpload(
  businessId: string,
  body: CreateUploadRequest,
): Promise<UploadDto> {
  const { data } = await http.post<UploadDto>(
    `/businesses/${businessId}/uploads`,
    body,
  );
  return data;
}
